import type { FC } from 'react';

import classNames from 'classnames';

import type { UploaderState } from '@iconik-io/uploader/src/state';

import Ellipsis from '../../components/ellipsis/ellipsis';
import { Link } from '../../components/link/link';
import { SHARE_COLLECTION_PAGE_ROUTE } from '../../constants/routes';
import {
  getUploadAssetId,
  getUploadTitle,
} from '../../ducks/uploader/upload_state';
import { getObjectLinkDeprecated } from '../../pages/share/utils';
import { useLeafRouteParams } from '../../router/use_leaf_route_params';
import { useAppSelector } from '../../store/react_redux_typed';
import AssetIcon from './asset_icon';
import { getUploaderFilePath } from './helpers';
import { selectIsUploaderFullScreen } from './selectors';

import styles from './uploads_panel_widget.module.css';

type Props = {
  item: UploaderState;
};

const FileTitle: FC<Props> = ({ item }) => {
  const { route, params } = useLeafRouteParams();
  const fullscreen = useAppSelector((state) =>
    selectIsUploaderFullScreen(state, params.id, params.versionId, route),
  );
  const path = useAppSelector((state) => getUploaderFilePath(state, item));
  const assetId = getUploadAssetId(item);
  const link =
    route === SHARE_COLLECTION_PAGE_ROUTE
      ? getObjectLinkDeprecated(assetId, 'assets')
      : `/asset/${assetId}`;
  const value = getUploadTitle(item);
  const title = assetId ? (
    <Link className={classNames(styles.title, styles.ellipsis)} to={link}>
      {value}
    </Link>
  ) : (
    <Ellipsis
      componentProps={{ className: classNames(styles.title, styles.ellipsis) }}
    >
      {value}
    </Ellipsis>
  );

  return (
    <div className={styles.title_root}>
      <AssetIcon item={item} />
      <div className={styles.title_text}>
        {title}
        {path && fullscreen ? (
          <Ellipsis
            componentProps={{
              className: classNames(styles.title_path, styles.ellipsis),
            }}
          >
            {path}
          </Ellipsis>
        ) : undefined}
      </div>
    </div>
  );
};

export default FileTitle;
